import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { RencanaAskepRequest, RencanaAskepResponseItem } from "@/types/cppt";

async function create(data: RencanaAskepRequest) {
  const response = await http.postData("/rencana-askep", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function update(id: number, data: RencanaAskepRequest) {
  const response = await http
    .putData(`/rencana-askep/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data.data;
}

async function getByRegister(
  register_id: string | number
): Promise<{ status: number; data: RencanaAskepResponseItem[] }> {
  const response = await http
    .getData(`/register/${register_id}/rencana-askep`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function destroy(id: number, alasan: string) {
  const response = await http
    .deleteDataParam(`/rencana-askep/${id}`, {
      params: {
        alasan: alasan
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function verify(id: number, unit_id?: string | null) {
  const response = await http
    .postData(`/rencana-askep/${id}/verifikasi`, unit_id ? { unit_id } : {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  create,
  update,
  getByRegister,
  destroy,
  verify
};
